import React from "react";
import { useTranslation } from "react-i18next";

import { CustomModalButtons } from "../../constants/global.constants";
import { combineClassNames } from "../../utils/appUtils";
import IconButton from "../IconButton";
import CloseIcon from "../SVGs/CloseIcon";
import WPButton from "../WPButton";
import WPHeading from "../WPHeading";
import WPLoader from "../WPLoader";

import StyledCustomModal from "./StyledCustomModal";

const CustomModal = ({
  header,
  headerHelper,
  confirmBtn,
  confirmBtnDisabled,
  cancelBtn,
  children,
  onModalClose,
  customclass,
  custombodyclass,
  width,
  cancelBtnDisabled,
  isLoading,
  loadingText,
  cancelBtnType,
  confirmBtnType,
  size,
  invisible,
  modalFooter,
  hideCloseIcon,
  headerTooltip,
  headerClass = "",
  headerDataTestId,
  headerTooltipPlacement,
  hideFooter,
  confirmBtnTooltip,
}) => {
  const { t } = useTranslation();

  const handleBtnClick = (id) => {
    if (onModalClose) {
      onModalClose({ target: { id } });
    }
  };

  return (
    <StyledCustomModal
      show
      centered
      className={combineClassNames(customclass, invisible && "invisible")}
      width={width}
      size={size}
      backdrop={!invisible}
      enforceFocus={false}
      scrollable
    >
      {isLoading && <WPLoader loadingMsg={loadingText} />}
      <StyledCustomModal.Header>
        <div className={headerClass} data-test-id={headerDataTestId || "wp-modal-header"}>
          <WPHeading size={size} tooltip={headerTooltip} tooltipPlacement={headerTooltipPlacement}>
            {header}
          </WPHeading>
          <WPHeading
            className="subHeading"
            size="small"
            secondary
            color="rgba(0, 0, 0, 0.45)"
          >
            {headerHelper}
          </WPHeading>
        </div>
        {!hideCloseIcon && (
          <IconButton
            id="modal-close-icon"
            tooltip={t("ValueStrings.close")}
            onClick={() => handleBtnClick(CustomModalButtons.CLOSE_BTN)}
          >
            <CloseIcon />
          </IconButton>
        )}
      </StyledCustomModal.Header>
      <StyledCustomModal.Body>
        <div className={custombodyclass ? custombodyclass : "modal-body-container"}>
          {children}
        </div>
      </StyledCustomModal.Body>
      {!hideFooter && (
        <StyledCustomModal.Footer>
          {modalFooter}
          <div className="action-btns">
            {cancelBtn && (
              <WPButton
                type={cancelBtnType}
                variant="outlined"
                id={CustomModalButtons.CANCEL}
                onClick={() => handleBtnClick(CustomModalButtons.CANCEL)}
                disabled={cancelBtnDisabled}
              >
                {cancelBtn}
              </WPButton>
            )}
            {confirmBtn && (
              <WPButton
                type={confirmBtnType}
                disabled={confirmBtnDisabled}
                id={CustomModalButtons.CONFIRM}
                onClick={() => handleBtnClick(CustomModalButtons.CONFIRM)}
                tooltip={confirmBtnTooltip}
              >
                {confirmBtn}
              </WPButton>
            )}
          </div>
        </StyledCustomModal.Footer>
      )}
    </StyledCustomModal>
  );
};

CustomModal.defaultProps = {
  header: "",
  headerHelper: "",
  confirmBtn: "",
  confirmBtnDisabled: false,
  cancelBtn: "",
  cancelBtnDisabled: false,
  isLoading: false,
  loadingText: "",
  cancelBtnType: "primary",
  confirmBtnType: "primary",
  size: "medium",
  invisible: false,
  modalFooter: null,
  hideCloseIcon: false,
  headerTooltip: "",
  headerClass: "",
  headerDataTestId: "",
  headerTooltipPlacement: "top",
  hideFooter: false,
  confirmBtnTooltip: "",
  customclass: "",
  custombodyclass: "",
  width: "1188px",
  hideCloseIcon: false,
  children: null,
  onModalClose: () => {},
};

export default CustomModal;
